import React from 'react';

import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';

import citySketch from '@kamernet/assets/CitySketch.webp';
import { AuthAction, AuthSource } from '@kamernet/core/Auth/types';
import { useAuthenticationRouting } from '@kamernet/core/Auth/useAuthenticationRouting';
import { useIntl } from '@kamernet/core/Intl';

import styles from './SignupCard.module.css';

interface SignupCardProps {
  hideImage?: boolean;
  title: string;
  subtitle: string;
  buttonMessage: string;
}

const SignupCardInternal: React.FC<SignupCardProps> = ({
  hideImage = false,
  title,
  subtitle,
  buttonMessage,
}) => {
  const { T } = useIntl();
  const { navigateToAuthentication } = useAuthenticationRouting();

  const handleSignupClick = React.useCallback(() => {
    navigateToAuthentication({
      action: AuthAction.Signup,
      source: AuthSource.SearchAlert,
    });
  }, [navigateToAuthentication]);

  return (
    <Card className={styles.root}>
      <CardContent className={styles.cardContent}>
        <div className={styles.cardText}>
          <Typography variant="h5" component="span">
            {title}
          </Typography>
          <Typography variant="body2" component="span">
            {subtitle}
          </Typography>
        </div>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleSignupClick}
        >
          {buttonMessage}
        </Button>
      </CardContent>
      {!hideImage && (
        <div className={styles.mediaWrapper}>
          <CardMedia
            component="img"
            className={styles.media}
            image={citySketch.src}
            alt={T('search_alerts.ldp.cta.sign_up')}
            loading="lazy"
          />
        </div>
      )}
    </Card>
  );
};

export const SignupCard = React.memo(SignupCardInternal);
